import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// 🚀 CONFIGURACIÓN DE URL
const API_BASE_URL = 'https://backend-bambos.onrender.com'; 

function Registro() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    usuario: '',
    password: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegistro = async () => {
    // Validar contraseñas en el cliente
    if (formData.password !== formData.confirmPassword) {
      alert("Las contraseñas no coinciden");
      return;
    }

    try {
      // 🔗 Apunta a Render de manera segura
      const response = await fetch(`${API_BASE_URL}/api/registro/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: formData.nombre,
          email: formData.email,
          usuario: formData.usuario,
          password: formData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // 📢 AJUSTE DE MENSAJE: Ahora le avisa que revise su bandeja de entrada (o spam)
        alert("¡Registro exitoso! 📩 Te hemos enviado un correo de bienvenida. Recuerda revisar tu bandeja de Spam si no lo encuentras.");
        navigate('/login');
      } else {
        // Muestra los errores de duplicados (Email en uso / Usuario en uso) que configuramos en Django
        if (data.email) {
          alert(`Error: ${data.email}`);
        } else if (data.usuario) {
          alert(`Error: ${data.usuario}`);
        } else {
          alert("Error en el registro: " + JSON.stringify(data));
        }
      }
    } catch (error) {
      alert("No se pudo conectar con el servidor backend. Verifica tu conexión o el estado del servidor.");
    }
  };

  // --- ESTILOS ---
  const containerStyle = { backgroundColor: '#000', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', color: '#fff' };
  const formBoxStyle = { backgroundColor: '#111', padding: '40px', borderRadius: '15px', width: '100%', maxWidth: '450px', border: '1px solid #222', boxShadow: '0 10px 30px rgba(0,0,0,0.8)', textAlign: 'center' };
  const inputGroup = { marginBottom: '20px', textAlign: 'left' };
  const labelStyle = { display: 'block', color: '#FFD700', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', textTransform: 'uppercase' };
  const inputStyle = { width: '100%', padding: '12px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '14px', outline: 'none', boxSizing: 'border-box' };
  const btnRegisterStyle = { width: '100%', padding: '15px', backgroundColor: '#FFD700', color: '#000', border: 'none', borderRadius: '8px', fontWeight: '900', cursor: 'pointer', textTransform: 'uppercase', marginTop: '10px', fontSize: '16px' };

  return (
    <div style={containerStyle}>
      <h2 style={{ color: '#FFD700', marginBottom: '30px', letterSpacing: '2px' }}>REGISTRARSE</h2>
      <div style={formBoxStyle}>
        <form onSubmit={(e) => e.preventDefault()}>
          <div style={inputGroup}>
            <label style={labelStyle}>Nombre Completo</label>
            <input type="text" name="nombre" value={formData.nombre} style={inputStyle} placeholder="Ej: Juan Pérez" onChange={handleChange} />
          </div>
          <div style={inputGroup}>
            <label style={labelStyle}>Correo Electrónico</label>
            <input type="email" name="email" value={formData.email} style={inputStyle} placeholder="correo@ejemplo.com" onChange={handleChange} />
          </div>
          <div style={inputGroup}>
            <label style={labelStyle}>Nombre de Usuario</label>
            <input type="text" name="usuario" value={formData.usuario} style={inputStyle} placeholder="bambo_user123" onChange={handleChange} />
          </div>
          <div style={inputGroup}>
            <label style={labelStyle}>Contraseña</label>
            <input type="password" name="password" value={formData.password} style={inputStyle} placeholder="********" onChange={handleChange} />
          </div>
          <div style={inputGroup}>
            <label style={labelStyle}>Confirmar Contraseña</label>
            <input type="password" name="confirmPassword" value={formData.confirmPassword} style={inputStyle} placeholder="********" onChange={handleChange} />
          </div>

          <button 
            type="button" 
            style={btnRegisterStyle}
            onClick={handleRegistro}
          >
            REGISTRARME
          </button>
        </form>

        <p style={{ marginTop: '25px', fontSize: '14px', color: '#888' }}>
          ¿Ya tienes una cuenta? {' '}
          <span 
            onClick={() => navigate('/login')} 
            style={{ color: '#FFD700', cursor: 'pointer', fontWeight: 'bold', textDecoration: 'underline' }}
          >
            Inicia Sesión
          </span>
        </p>    
      </div>
      <button onClick={() => navigate('/')} style={{ marginTop: '30px', background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '12px' }}>
        ← Volver al inicio
      </button>
    </div>
  );
}

export default Registro;